import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const FinalCTASection = () => {
  return (
    <section
      className="relative border-t border-white/10 overflow-hidden py-28 md:py-40"
      style={{ background: 'linear-gradient(180deg, #0a0a0c 0%, #141420 100%)' }}
    >
      <div
        aria-hidden
        className="absolute inset-0 grid place-items-center pointer-events-none font-display italic font-black leading-[0.8] tracking-[-0.04em]"
        style={{
          color: 'rgba(255,255,255,0.02)',
          fontSize: 'clamp(200px, 36vw, 560px)',
          transform: 'skewX(-10deg)',
        }}
      >
        GO.
      </div>

      <div className="relative z-10 container mx-auto px-4 lg:px-8 text-center max-w-[900px]">
        <div className="font-mono text-[11px] tracking-[0.14em] uppercase text-primary mb-5">
          // ÉPILOGUE
        </div>
        <h2 className="m-0 leading-[0.9]">
          <span className="font-display italic uppercase -skew-x-6 inline-block text-[52px] md:text-[80px] lg:text-[120px] text-foreground">
            TA PROCHAINE COURSE
          </span>
          <br />
          <span
            className="font-display italic uppercase -skew-x-6 inline-block text-[52px] md:text-[80px] lg:text-[120px] text-transparent bg-clip-text"
            style={{ backgroundImage: 'linear-gradient(90deg, #caff00 0%, #f8ff3a 35%, #ff7a1a 65%, #ff2d9e 100%)' }}
          >
            T'ATTEND.
          </span>
        </h2>
        <p className="mt-8 max-w-[620px] mx-auto text-lg leading-relaxed text-muted-foreground">
          Une seule plateforme française pour trouver ta prochaine course, gérer tes justificatifs et garder l'œil sur tes dossards. Le reste, c'est à toi de le{' '}
          <b className="text-foreground">courir</b>.
        </p>

        <div className="mt-12 flex flex-wrap gap-3 justify-center">
          <Button
            asChild
            className="rounded-full bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-6 text-sm font-bold uppercase tracking-[0.08em] gap-2"
          >
            <Link to="/explorer">
              Trouver ma prochaine course
              <ArrowRight className="w-4 h-4" />
            </Link>
          </Button>
          <Button
            asChild
            variant="outline"
            className="rounded-full border-white/20 px-8 py-6 text-sm font-bold uppercase tracking-[0.08em] hover:bg-white/5"
          >
            <Link to="/auth">Créer un compte</Link>
          </Button>
        </div>

      </div>
    </section>
  );
};

export default FinalCTASection;
